import { render, staticRenderFns } from "./SelectClinic.vue?vue&type=template&id=7c91e250&"
import script from "./SelectClinic.vue?vue&type=script&lang=js&"
export * from "./SelectClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports